import protocolList, {
  EducationProtocolListParams
} from "@/getinfo-api/education-protocol";
import api from "@/getinfo-api";
import { MainList } from "@/classes/MainList";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import { getCurrentEmployee } from "@/plugins/roles";

export class EducationProtocolListClass extends MainList {
  params: EducationProtocolListParams = {
    ownerId: this.isNeedOwnerId ? undefined : this.employee.id,
    companyId: this.companyId,
    limit: 30,
    offset: 0
  };

  constructor(params?: any, selectedValue?: string | undefined) {
    super();
    this.method = protocolList;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    // this.dataLabel = "items";
    if (selectedValue) {
      this.singleMethod = () => api.EducationProtocolApi.get(selectedValue);
      this.single();
    }
    this.list();
  }

  get employee() {
    return getCurrentEmployee();
  }

  search(value: string) {
    this.params.number = value;
    this.params.offset = 0;
    this.listItems = [];
    this.list();
  }

  get protocols(): Array<IEducationProtocol> {
    return this.listItems;
  }
}
